define('skin/newsroom/Serum.Newsroom',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'skin/newsroom/tinycon',
  'common/module/asset/Serum.Asset.Fragment'
], function($, Pubsub, Tinycon, Fragment) {
  'use strict';

  // this function is redefined if visibiliy API is supported
  var isVisible = function() {
    return true;
  };

  var ENDS_WITH_SLASH = /\/$/;

  function isNewsroomPath (pathname) {
    return ENDS_WITH_SLASH.test(pathname);
  }

  // show/hide/update notifications about incoming ab messages
  var StreamNotification = (function() {

    var NOTIFICATION_MARKUP =
      '<div class="newsroom-notification skin-background">' +
      '<span class="compilation-item-count count">1</span> <span class="message">ny melding</span>' +
      '<div class="status-line">' +
      '<div class="status-line-top skin-background"></div>' +
      '<div class="status-line-bottom"></div>' +
      '</div>' +
      '</div>';

    var $notification = $(NOTIFICATION_MARKUP);

    $notification.on('click', function() {
      setTimeout(function() {
        $('body, html').animate({
          scrollTop: $('.stream-content').offset().top - 35
        }, 800);
      }, 0);
    });

    return {
      updateCount: function(count) {

        $notification.find('.count').html(count);
        $notification.find('.message').html(count > 1 || !count ? 'nye meldinger' : 'ny melding');
        if (!isVisible()) {
          Tinycon.setBubble(count);
        }
      },

      show: function() {
        $notification.appendTo('body');
        setTimeout(function() {
          $notification.addClass('active');
        }, 100);
      },

      hide: function() {
        $notification.removeClass('active');
        $notification.detach();
        Tinycon.reset();
      }

    };
  })();

  var BulletinAuthors = (function() {

    var updateTimestamp;

    function getAuthors() {
      var authors = [],
        authorsMap = {},
        now = (new Date()).getTime();

      // Push all authors in array
      var authorBulletins = $('.bulletin[data-author-id]');
      // For newsroom, only include bulletins that originates from current context
      if (isNewsroomPath(location.pathname)) {
        authorBulletins = authorBulletins
          .has('.bulletin-time>a[href*="nrk.no' + location.pathname + '"]')
      }
      authorBulletins.each(function() {
        var $bulletin = $(this);
        authors.push({
          timestamp: $bulletin.data('timestamp'),
          id: $bulletin.data('authorId')
        });
      });

      // Make authors unique
      authors = authors.filter(function(author) {
        if (authorsMap[author.id]) {
          return false;
        }
        authorsMap[author.id] = 1;
        return true;
      });

      // Only return authors that posted within last hour
      authors = authors.filter(function(author) {
        var cutoff = 3600000;
        var diff = now - author.timestamp;
        return diff < cutoff;
      });

      return authors;
    }

    function fetchAuthors() {
      updateTimestamp = (new Date()).getTime();

      var $authorsContainer = $('.compilation-authors');

      // IIFE to pass in and keep scoped parameters
      (function(runningTimestamp, authors) {

        // If we got any athors
        if (authors.length) {
          // force small delay to await more incoming fragments
          setTimeout(function() {

            // only do something if we are on last update
            if (runningTimestamp === updateTimestamp) {
              $authorsContainer.empty().addClass('show');
              authors.forEach(function(author) {
                Fragment.render(author.id, null, {
                  perspective: 'BRIEF'
                }, {
                  stripWhitespace: false,
                  onUpdate: function($author) {
                    // only add content if we are on last update
                    if (runningTimestamp === updateTimestamp) {
                      $authorsContainer.append($author);
                    }
                  }
                });
              });
            }
          }, 100);
        } else {
          $authorsContainer.removeClass('show');
        }

      })(updateTimestamp, getAuthors());
    }

    return {
      update: function() {
        fetchAuthors();
      }
    };
  })();

  // manages seen/unseen state of messages
  var BulletinStateManager = (function(namespace, maxItems) {

    var NAMESPACE = namespace || 'nrk.newsroom.seen-items';
    var MAX_SEEN_ITEMS = maxItems || 10000;

    var seenItems = (function() {
      var items = localStorage.getItem(NAMESPACE);

      if (!items) {
        return [];
      }
      return JSON.parse(items);
    })();

    // returns true if the element is visible in viewport, false otherwise
    function isElementVisible($element) {
      var element = $element.get(0),
        rectangle = element.getBoundingClientRect(),
        bottomEdgeVisible = rectangle.bottom <= (window.innerHeight || $(window).height());

      return rectangle.top >= 0 && bottomEdgeVisible || bottomEdgeVisible;
    }

    // marks an item as "seen"
    function markItemAsSeen($item) {
      var id = $item.attr('data-id');
      $item.addClass('newsroom-seen');


      // keep seen item id, clamp size
      seenItems.push(id);
      if (seenItems.length > MAX_SEEN_ITEMS) {
        seenItems.shift();
      }
    }

    // returns true if the specified element is read, false
    function itemIsSeen($item) {

      var id = $item.attr('data-id');
      var readItems = localStorage.getItem(NAMESPACE);

      if (!readItems) {
        return false;
      }

      readItems = JSON.parse(readItems);

      return readItems.indexOf(id) !== -1;
    }

    function isSupported() {
      return typeof document.documentElement.getBoundingClientRect !== 'undefined' &&
        typeof window.JSON === 'object';
    }

    function storeAndTrimIfNeeded(iterations) {
      // default iterations to zero
      iterations = iterations || 0;
      // catch localStorage exceptions
      try {
        localStorage.setItem(NAMESPACE, JSON.stringify(seenItems));
      } catch (domException) {
        if (domException.name === 'QuotaExceededError' || domException.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
          // chop off first 25% of array
          seenItems = seenItems.slice(Math.round(seenItems.length * 0.25));
          // limit recursive calls to 10x and array length over 100
          if (iterations < 10 && seenItems.length > 100) {
            storeAndTrimIfNeeded(++iterations);
          }
        }
      }
    }

    // store state on unload
    $(window).on('unload', function() {
      storeAndTrimIfNeeded();
    });

    return {
      markItemAsSeen: markItemAsSeen,
      itemIsSeen: itemIsSeen,
      isElementVisible: isElementVisible,
      isSupported: isSupported
    };
  })();

  // display/hide notification on stream insertions
  function onStreamInsertionCountChange(data) {

    var count = data.unrenderedInsertionCount || 0;

    if (count === 0) {
      StreamNotification.hide();
      return;
    }

    StreamNotification.updateCount(count);
    StreamNotification.show();
  }


  function setupNotifications() {
    Pubsub.subscribe('/stream/underedInsertionCountChange', onStreamInsertionCountChange);
  }

  function setupVisibilityHandling() {
    var property = null;

    if ('hidden' in document) {
      property = 'hidden';
    }

    if (!property) {
      return;
    }

    // redefine visibility function
    isVisible = function() {
      return !document[property];
    };

    var eventName = property.replace(/[H|h]idden/, '') + 'visibilitychange';

    $(document).on(eventName, function() {
      Pubsub.publish('VISIBILITY_DID_CHANGE_STATE', {
        visible: isVisible()
      });
    });

    Tinycon.setOptions({
      colour: '#ffffff',
      background: '#bb0011',
      fallback: true
    });

  }


  function setupUnreadHandling() {
    if (!BulletinStateManager.isSupported()) {
      return;
    }

    function checkReadStatus() {

      // XXX: ornery code
      $('.stream-item:not(.newsroom-seen), .surrogate > .teaser-reference > .bulletin').each(function() {
        var $item = $(this);

        if (BulletinStateManager.itemIsSeen($item)) {
          $item.addClass('newsroom-seen');

        } else if (BulletinStateManager.isElementVisible($item)) {
          BulletinStateManager.markItemAsSeen($item);

          setTimeout(function() {
            $item.removeClass('newsroom-unseen').addClass('newsroom-seen');
          }, 300);
        }
      });

      setTimeout(function() {
        $('.newsroom-seen-unresolved').removeClass('newsroom-seen-unresolved');
      }, 0);
    }

    checkReadStatus();

    Pubsub.subscribe(Pubsub.topics.DID_SCROLL, checkReadStatus);
    $(document).on('afterrealtimeinsertion', function() {
      setTimeout(checkReadStatus, 0);
    });
  }

  function setupBulletinAuthorInjection() {

    function updateBulletinAuthors() {
      BulletinAuthors.update();
    }

    updateBulletinAuthors();

    $(document).on('afterrealtimeinsertion', function() {
      setTimeout(updateBulletinAuthors, 0);
    });
  }

  function bootstrap() {
    $(document).ready(function() {
      setupBulletinAuthorInjection();
      setupUnreadHandling();
    });

    setupNotifications();
    setupVisibilityHandling();
  }

  return {
    bootstrap: bootstrap,

    //exposed for testing only
    _isNewsroomPath: isNewsroomPath
  };

});

